export function camelCaseToTitleCase(input: string): string {
  // Add a space before any uppercase letter and convert the first letter to uppercase
  return input
    .replace(/([A-Z])/g, " $1") // Insert space before uppercase letters
    .replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter
}
